<script>
import "./style.scss";
import template from "./template.html";
import {Event} from "vue-tables-2";
import {LoadingIcon} from "../../icons.js";
import {nanoid} from "nanoid";
import {values, isObject} from "lodash";
import moment from "moment";
import {mapState} from "vuex";
import AccountSearch from "../../Dropdown-Search/account-user.vue";
import axios from "axios";

let abortController;

export default {
  template,
  components: {
    LoadingIcon,
    AccountSearch,
  },
  props: {
    signOutUrl: {
      type: String,
      default: "",
    },
    allDeviceLogoutUrl: {
      type: String,
      default: "",
    },
    sessionId: {
      type: String,
      default: "",
    },
    myId: {
      type: String,
      default: "",
    },
    myName: {
      type: String,
      default: "",
    },
    isAdminLoggedIn: {
      type: Boolean,
      default: false,
    },
    searchRoute: {
      type: String,
      default: "",
    },
    options: {
      type: Object
    },
    viewableUsersRoute: {
      type: String,
      default: "",
    }
  },
  created () {
    this.userId = this.myId;
    let urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has('filter')) {
      if (urlParams.get('filter') === 'active_sessions' && this.isAdminLoggedIn) {
        this.showActiveSessions(false);
      }
    }
    Event.$on("vue-tables.pagination", (currentPage) => {
      this.currentPage = currentPage;
      this.isLoading = true;
    });

    Event.$on("vue-tables.sorted", () => {
      this.isLoading = true;
    });

    Event.$on("vue-tables.refresh-table", () => {
      this.$refs.table.refresh();
    });
    let isFirstLoad = true;

    const requestFunction = (data) => {
      let {page, limit, ascending, query, accountList, orderBy} = data;
      let sortDir = ascending ? "a" : "d";
      let accountId = this.accountId;
      let userId = this.userId;
      let params = {
        userId,
        page,
        limit,
        sortDir,
        accountId,
        query,
        accountList,
        orderBy
      };

      if (this.activeSessionsFilter) params['filterBy'] = 'activeSessions';

      return this.search(params).then((result) => {
        if (isFirstLoad) {
          this.tableOptions.totalPages = this.resultsCount;
          isFirstLoad = false;
        }

        if (!this.isAdminLoggedIn) {
          this.gridHeading = 'My Login Details';
        }
        else if (params.filterBy){
          this.gridHeading = 'Login Details';
        }
        else if (result.data.length) {
          let userOrAccount = (params.accountId) ? result.data[0].account : result.data[0].user;
          this.gridHeading = 'Login Details for ' + userOrAccount;
        }
        else {
          this.gridHeading = 'No results found';
        }

        this.isLoading = false;
        //if the request is cancelled and no data is returned
        //return the current data so we don't have an empty grid


        return {
          data: result || {
            data: this.sessionRecords,
            count: this.resultsCount,
          },
        };
      });
    };
    const setOptions = (options) => {
      const defaultOpts = {
        filterable: false,
        editableColumns: [],
        perPage: 10,
        sortable: ["logged_in", "logged_out", "user", "IP_address"],
        totalPages: null,
        requestFunction,
        requestAdapter (data) {
          return {
            limit: data.limit,
            page: data.page,
            ascending: !data.ascending,
            orderBy: data.orderBy ? data.orderBy : 'logged_in'
          };
        },
        texts: {
          noResults:
              'Search or Filter returned no results. <span class="clickable">Reset Filter(s)</span>',
        },
      };
      return Object.assign({}, defaultOpts, options);
    };

    this.tableOptions = setOptions(this.options)
  },
  computed: {
    ...mapState("AuthStore", {
      sessionRole: "role",
      sessionAccount: "account",
    }),
    showAccountsDropdown () {
      return this.isAdminLoggedIn;
    },
    showUsersDropdown () {
      return this.isAdminLoggedIn;
    },
    haveSessionData() {
      return this.resultsCount > 0
    },
    showActiveSessionsFilter() {
      return this.isAdminLoggedIn;
    },
    sectionClass() {
      return this.isAdminLoggedIn ? 'adjust-width' : 'width-100'
    }
  },
  methods: {
    setAccountFilter (data) {
      this.userId = null;
      this.accountId = data.id;
      this.activeSessionsFilter = false;
      this.showingLoginDetailsForName = data.name;
      this.refreshTable();
    },
    setUserFilter (data) {
      this.accountId = null;
      this.userId = data.id;
      this.activeSessionsFilter = false;
      this.showingLoginDetailsForName = data.fullname;
      this.refreshTable();
    },
    resetFilters () {
      let data = {'id': this.myId};
      this.setUserFilter(data);
    },
    refreshTable () {
      this.$refs.table.refresh();
    },
    signOutUser (session_id) {
      if (session_id) {
        axios
            .post(this.signOutUrl, {
              id: session_id,
            })
            .then((response) => {
              if (response?.data?.success == 1) {
                this.refreshTable();
              }
            })
            .catch((err) => {
              console.log(err);
            });
      }
    },
    signOutAllDevices () {
      showPopupContent("Sign Out from All Devices", "600", getLogoutAllContent);
    },
    search (options = {}) {
      let requestId = nanoid();

      let params = Object.assign({}, params, options);
      //cancel previous search request
      if (this.requestsInProgress.length && abortController) {
        abortController.abort();
      }

      this.requestsInProgress.push(nanoid);        // Cancel any in-progress requests
        if (abortController) {
          abortController.abort();
        }
        abortController = new AbortController();

        return axios
          .get(this.searchRoute, {
            params,

            signal: abortController.signal,
          })
          .then((response) => {
            let {columns, data, aggregates, user_prefs} = response.data;
            this.sessionRecords = data;
            this.aggregates = aggregates;

            //create an array of column names
            let columnNames = values(columns).map((c) => c.displayName);

            //set the total available matching results
            this.resultsCount = parseInt(aggregates.total_sessions_count || 0);
            this.resultsCountText = (this.resultsCount > 1) ? 'Sessions' : 'Session';
            //set user preferences
            if (isObject(user_prefs)) {
              this.userPrefs = Object.assign({}, this.userPrefs, user_prefs);
            }

            if (!this.columns.length) {
              this.columns.length = 0;
              columnNames.forEach((column) => this.columns.push(column));
            }

            return {
              count: this.resultsCount,
              data: this.sessionRecords,
            };
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log("req cancelled", error.message);
            }
          })
          .finally(() => {
            //remove the request id from requests queue
            this.requestsInProgress.splice(
                this.requestsInProgress.indexOf(requestId),
                1
            );
          });
    },
    reset () {
      this.resultsCount = 0;
      this.sessionRecords.splice(0, this.sessionRecords.length);
    },
    formatDate (date) {
      if (!date || !moment(date).isValid()) return false;
      return moment(date).format("DD-MMM-YYYY h:mm A");
    },
    getBrowserDetails (data) {
      let device_details = "-";
      if (data) {
        data = JSON.parse(data);
        device_details = data.browserFamily + " on " + data.platformName;
      }
      return device_details;
    },
    getLocationDetails (data) {
      let location_details = "";
      if (data) {
        data = JSON.parse(data);
        if (data.location)
          location_details =
              "(" +
              data.location.regionName +
              ", " +
              data.location.countryName +
              " " +
              data.location.countryCode +
              ")";
      }
      return location_details;
    },
    showSignOut(row) {
      return !this.formatDate(row.logout_time) && row.session_id != this.sessionId && row.user_id == this.myId
    },
    getGridHeading() {
      return (!this.isAdminLoggedIn) ? 'My Login Details' : 'Login Details for ' + this.myName;
    },
    showActiveSessions(refresh = true) {
      this.userId = null;
      this.accountId = null;
      this.activeSessionsFilter = true;
      if (refresh) {
        this.refreshTable();
      }
    },
  },
  data () {

    return {
      gridHeading: this.getGridHeading(),
      userId: null,
      accountId: null,
      perPageValues: [10, 25, 50, 100],
      pagination: {
        show: true,
        dropdown: true,
        virtual: true,
      },
      isLoading: false,
      requestsInProgress: [],
      currentPage: 1,
      resultsCount: 0,
      resultsCountText: 'Session',
      columns: [],
      aggregates: {},
      userPrefs: {},
      sessionRecords: [],
      tableOptions: {},
      showingLoginDetailsForName: this.myName,
      activeSessionsFilter: false,
    };
  },
};
</script>
